// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/traffic-circuit.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/traffic-circuit/traffic-circuit.js';

mount([g0]);
